var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:({
		backgroundImage:
			!this.$route.path.includes('/login') &&
			!this.$route.path.includes('/signup') &&
			!this.$route.path.includes('/resetpassword')
				? ''
				: 'url(' + _vm.background + ')',
		height: !_vm.isAuth ? '100vh' : 'auto'
	})},[_c('loading-screen'),_c('el-container',{staticStyle:{"display":"block","overflow-y":"hidden"}},[(_vm.isAuth && _vm.user.organization)?_c('app-header'):_vm._e(),(!_vm.isAuth || _vm.user.organization)?_c('el-main',{staticStyle:{"overflow-y":"hidden"},style:({ padding: !_vm.isAuth ? '0' : '20px' })},[_c('div',{style:({ 'overflow-y': !_vm.isAuth ? 'scroll !important' : 'hidden' })},[_c('router-view')],1)]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }